module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-sg/desktop-a2c511e71f7f60a4dbace201de38c560.png";